import React from "react";
import { useRecordContext } from "react-admin";

type TotalFieldProps = {
  record?: any;
  sortable?: boolean;
  source: string;
};

export const TotalField = (props: TotalFieldProps) => {
  const record = useRecordContext();

  if (record === undefined) {
    return null;
  }

  const total: number = record[props.source];
  const totalSelfInspect: number = record["total_self_inspect"];

  return <span {...props}>{`${total}(${totalSelfInspect})`}</span>;
};
